<script>
import BlogSinglePagesComponent from '../features/lists/BlogSinglePagesComponent';
import FooterView from '../../shared/views/MainFooterView';
import BrandLogo from '../../shared/BrandLogo.vue';
export default {
  name: 'BlogSinglePageView',
  components: {
        'brand-logo': BrandLogo,
    'footer-view': FooterView,
  },
  extends: BlogSinglePagesComponent,
};
</script>

<template>
  <div class="public-page-wrapper">
    <!-- Header -->
    <header class="public-header">
      <div class="public-header__inner">
        <router-link to="/">
          <brand-logo variant="dark" />
        </router-link>
        <nav class="public-header__nav">
          <router-link to="/">Inicio</router-link>
          <router-link to="/acerca">Acerca</router-link>
          <router-link to="/cursos">Cursos</router-link>
          <router-link to="/noticias">Noticias</router-link>
          <router-link to="/contacto">Contacto</router-link>
        </nav>
        <div class="public-header__actions">
          <router-link
            to="/login"
            class="btn-outline"
          >
            Iniciar Sesión
          </router-link>
          <router-link
            to="/registrarse"
            class="btn-fill"
          >
            Registrarse
          </router-link>
        </div>
      </div>
    </header>

    <!-- Article Hero -->
    <section
      v-if="item"
      class="public-hero article-hero"
    >
      <div class="public-hero__inner">
        <nav class="public-hero__nav">
          <router-link to="/">Inicio</router-link>
          <span>/</span>
          <router-link to="/noticias">Noticias</router-link>
          <span>/</span>
          <a
            href="#"
            class="active"
          >{{ item.current.title }}</a>
        </nav>
        <h1 class="public-hero__title">{{ item.current.title }}</h1>
        <p class="public-hero__subtitle">
          <i class="uil uil-calendar-alt" />
          {{ formatDate(item.current.createdAt) }}
        </p>
      </div>
    </section>

    <!-- Article Content -->
    <main
      v-if="item"
      class="article-body"
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <!-- Featured Image -->
            <div class="article-featured-image">
              <img
                :src="item.current.imageUrl || 'images/blog/img-1.jpg'"
                :alt="item.current.title"
              >
            </div>

            <!-- Article -->
            <div class="article-content">
              <div
                class="description"
                v-html="item.current.description"
              />
            </div>

            <!-- Navigation -->
            <div class="article-nav">
              <div class="row">
                <div class="col-md-6">
                  <a
                    v-if="item.preview"
                    class="article-nav-link article-nav-link--prev course-pointer"
                    @click="navigate(item.preview)"
                  >
                    <div class="article-nav-icon">
                      <i class="uil uil-angle-left" />
                    </div>
                    <div class="article-nav-text">
                      <span class="article-nav-label">Anterior</span>
                      <span class="article-nav-title">{{ item.preview.title }}</span>
                    </div>
                  </a>
                </div>
                <div class="col-md-6">
                  <a
                    v-if="item.next"
                    class="article-nav-link article-nav-link--next course-pointer"
                    @click="navigate(item.next)"
                  >
                    <div class="article-nav-text article-nav-text--right">
                      <span class="article-nav-label">Siguiente</span>
                      <span class="article-nav-title">{{ item.next.title }}</span>
                    </div>
                    <div class="article-nav-icon">
                      <i class="uil uil-angle-right" />
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <!-- Back to blog -->
            <div class="article-back">
              <router-link
                to="/noticias"
                class="btn-outline"
              >
                <i class="uil uil-arrow-left" /> Ver todas las noticias
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </main>

    <footer-view />
  </div>
</template>

<style scoped>
.article-hero {
  padding: 40px 24px 36px;
}

.article-hero .public-hero__subtitle {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}

.article-hero .public-hero__subtitle i {
  font-size: 16px;
}

.article-body {
  flex: 1;
  background: #f0f4f8;
  padding: 40px 24px;
}

.article-featured-image {
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 32px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1);
}

.article-featured-image img {
  width: 100%;
  height: auto;
  display: block;
  max-height: 450px;
  object-fit: cover;
}

.article-content {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 32px;
  margin-bottom: 32px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.article-content :deep(.description) {
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  color: #334155;
  line-height: 1.8;
}

.article-content :deep(.description h1),
.article-content :deep(.description h2),
.article-content :deep(.description h3),
.article-content :deep(.description h4) {
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  color: #0f172a;
  margin: 1.5em 0 0.75em;
  line-height: 1.3;
}

.article-content :deep(.description h2) {
  font-size: 1.5rem;
}

.article-content :deep(.description h3) {
  font-size: 1.25rem;
}

.article-content :deep(.description h4) {
  font-size: 1.125rem;
}

.article-content :deep(.description p) {
  margin: 0 0 1em;
}

.article-content :deep(.description a) {
  color: #0D47A1;
  text-decoration: none;
}

.article-content :deep(.description a:hover) {
  text-decoration: underline;
}

.article-content :deep(.description ul),
.article-content :deep(.description ol) {
  margin: 0 0 1em 1.5em;
}

.article-content :deep(.description li) {
  margin-bottom: 0.5em;
}

.article-content :deep(.description img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 1em 0;
}

.article-content :deep(.description blockquote) {
  border-left: 4px solid #0D47A1;
  margin: 1.5em 0;
  padding: 12px 20px;
  background: #EEF5FC;
  border-radius: 0 8px 8px 0;
  font-style: italic;
  color: #475569;
}

.article-content :deep(.description code) {
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
  color: #0f172a;
}

.article-content :deep(.description pre) {
  background: #1e293b;
  color: #e2e8f0;
  padding: 16px;
  border-radius: 8px;
  overflow-x: auto;
  margin: 1em 0;
}

.article-content :deep(.description pre code) {
  background: transparent;
  padding: 0;
  color: inherit;
}

/* Article Navigation */
.article-nav {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.article-nav-link {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  padding: 12px;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.article-nav-link:hover {
  background: #EEF5FC;
}

.article-nav-link--next {
  justify-content: flex-end;
  text-align: right;
}

.article-nav-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #EEF5FC, #D6E7F8);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.article-nav-icon i {
  font-size: 18px;
  color: #0D47A1;
}

.article-nav-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.article-nav-text--right {
  text-align: right;
}

.article-nav-label {
  font-family: 'Roboto', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  color: #0D47A1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.article-nav-title {
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  color: #334155;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Back Button */
.article-back {
  text-align: center;
  margin-bottom: 24px;
}

.article-back .btn-outline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  padding: 10px 20px;
}

/* Responsive */
@media (max-width: 768px) {
  .article-body {
    padding: 24px 16px;
  }

  .article-content {
    padding: 20px;
  }

  .article-featured-image {
    margin-bottom: 24px;
  }
}
</style>
